import React, { FC } from 'react'
import { PublicationCardItem } from '@news-mono/web-common'
import { StyledListCardKicker, StyledTopicLabel } from '../ListCard.styled'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import { ThemedRender } from '../../../__styling/themed-render'

interface ListCardTopicTagProps {
    item: MaybeLoaded<PublicationCardItem>
}

export const ListCardTopicTag: FC<ListCardTopicTagProps> = (props) => {
    const { item } = props

    if (!item || !item.loaded) {
        return null
    }

    return (
        <ThemedRender
            perthnow={() => (
                <StyledTopicLabel
                    topic={item.result.primaryTopic}
                    text={item.result.primaryTopic.title}
                />
            )}
            sevennews={() => (
                <StyledListCardKicker>
                    {item.result.kicker}
                </StyledListCardKicker>
            )}
        />
    )
}
ListCardTopicTag.displayName = 'ListCardTopicTag'
